import { useMemo } from 'react';
import { ChoiceDrill } from './ChoiceDrill';
import type { DrillProps } from './meta';
import { makePerceptRound, PERCEPT_CHOICES } from './percept';

export function PerceptDrill({ level, seed, onDone }: DrillProps) {
  const questions = useMemo(() => makePerceptRound(level, seed), [level, seed]);
  return (
    <ChoiceDrill
      questions={questions} seed={seed} onDone={onDone} className="percept-drill" marks={false} choicesClass="two"
      info={(q) => ({ left: q.left, right: q.right })}
      render={(q) => (
        <div className="percept-pair" aria-label="두 줄 비교">
          <div className="percept-str">{q.left}</div>
          <div className="percept-str">{q.right}</div>
        </div>
      )}
      renderChoice={(_, i) => <span className="choice-text">{i === 0 ? '← ' : ''}{PERCEPT_CHOICES[i]}{i === 1 ? ' →' : ''}</span>}
    />
  );
}
